import React, { useState } from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { RCButton, RCTextWithIcon, RCToast } from '@reverbdotcom/cadence/components';
import { NudgeExploreIcon } from '@reverbdotcom/cadence/icons/react';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import { parseAmountCents } from '@reverbdotcom/commons/src/money';

import QuickPriceEditModalV2 from '../listings/quick_price_edit/QuickPriceEditModalV2';
import SellerListingsCollectionContext from './SellerListingsCollectionContext';
import { RCTextUtility } from '@reverbdotcom/cadence/components/RCText/RCText';

interface Props {
  listing: Listing;
}

export default function PriceDropRecommendationPresentment({ listing }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const {
    useLazySellerListingsQuery,
  } = React.useContext(SellerListingsCollectionContext);
  const { refetchSellerListings } = useLazySellerListingsQuery();

  const priceMiddle = listing.priceRecommendation?.priceMiddle;
  const displayPrice = parseAmountCents(
    priceMiddle?.amountCents,
    priceMiddle?.currency,
    { precision: 0 },
  ).display;

  return (
    <>
      <div className="seller-listing-insight-presentment">
        <span className="seller-listing-insight-presentment__price-drop-recommendation">
          <RCTextWithIcon icon={<NudgeExploreIcon />} placement="left" size="large">
            <RCTextUtility size="350">
              <Translate text="discovery.listingsManagement.sellerListingCard.insights.priceDropRecommendation.title">
                <span className="weight-semibold">{displayPrice}</span>
              </Translate>
            </RCTextUtility>
          </RCTextWithIcon>
        </span>
        <RCButton
          variant="outlined"
          size="small"
          onClick={() => setIsModalOpen(true)}
          fullWidth
        >
          {I18n.t('discovery.listingsManagement.sellerListingCard.insights.priceDropRecommendation.adjustPrice')}
        </RCButton>
      </div>

      <QuickPriceEditModalV2
        isOpen={isModalOpen}
        listingId={listing.id}
        requestClose={() => setIsModalOpen(false)}
        onSuccessCallback={() => {
          setIsModalOpen(false);
          setShowToast(true);
          refetchSellerListings([listing.id]);
        }}
      />

      <RCToast
        isOpen={showToast}
        onClose={() => setShowToast(false)}
        text={I18n.t('discovery.listingsManagement.toast.message.success')}
        theme="success"
        delayInterval="short"
      />
    </>
  );
}
